import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
export function WhyOldFails() {
  return <Section className="text-center" data-id="element-196">
      <h2 className="text-3xl font-serif mb-8 text-warm-brown" data-id="element-197">
        Por qué lo que intentaste antes te cansó
      </h2>

      <p className="text-lg mb-8 text-warm-brown/80" data-id="element-198">
        Porque la mayoría de las soluciones están hechas para:
      </p>

      <ul className="space-y-4 max-w-md mx-auto mb-10" data-id="element-199">
        <li className="flex items-center justify-center gap-3 text-warm-brown/60 line-through decoration-terracotta decoration-2" data-id="element-200">
          <X size={16} className="text-terracotta" data-id="element-201" />
          <span data-id="element-202">gente con tiempo</span>
        </li>
        <li className="flex items-center justify-center gap-3 text-warm-brown/60 line-through decoration-terracotta decoration-2" data-id="element-203">
          <X size={16} className="text-terracotta" data-id="element-204" />
          <span data-id="element-205">gente sin culpa</span>
        </li>
        <li className="flex items-center justify-center gap-3 text-warm-brown/60 line-through decoration-terracotta decoration-2" data-id="element-206">
          <X size={16} className="text-terracotta" data-id="element-207" />
          <span data-id="element-208">gente con constancia alta</span>
        </li>
      </ul>

      <p className="text-xl font-serif text-warm-brown" data-id="element-209">
        Vos no necesitás más "contenido". <br data-id="element-210" />
        <span className="font-bold text-terracotta" data-id="element-211">Necesitás un piso.</span>
      </p>
    </Section>;
}